module.exports = __webpack_public_path__ + "static/media/game-help-icon.a8913cd4.svg";